"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerAppFlags = void 0;

var _featureFlags = require("../feature-flags");

var registerAppFlags = function registerAppFlags() {
  return _flagsInstanceProperty(_featureFlags).registerFlags({
    showFlags: 'show-flags',
    showOptions: 'options-show-t',
    disableExtendedSearch: 'no-extended-search-t',
    appBarSearchFilters: 'search-filters-t',
    disableAppBarPersonaSearch: 'no-search-persona-t',
    disableClickTale: 'no-clicktale',
    devEnableClickTale: 'dev-clicktale'
  });
};

exports.registerAppFlags = registerAppFlags;